"use strict";

exports.__esModule = true;
exports.TimelineDataTypeField = TimelineDataTypeField;
var _react = _interopRequireDefault(require("react"));
var _core = require("@blueprintjs/core");
var _Core = require("../../Core");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function TimelineDataTypeField(props) {
  var setType = props.setType,
    type = props.type;
  var _React$useContext = _react["default"].useContext(_Core.TranslatorContext),
    translate = _React$useContext.translate;
  var typeOptions = [{
    label: "String",
    id: "string"
  }, {
    label: "Date",
    id: "date"
  }, {
    label: "Device",
    id: "deviceName"
  }, {
    label: "Duration",
    id: "duration"
  }, {
    label: "State",
    id: "state"
  }, {
    label: "Activity",
    id: "activity"
  }, {
    label: "Number",
    id: "number"
  }];
  if (!type) {
    setType(typeOptions[0].id);
  }
  var selectedOption = typeOptions.find(function (option) {
    return option.id === type;
  });
  return /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
    label: translate("DataTypeField.dataType.label", "Column Data Type"),
    helperText: translate("DataTypeField.dataType.helperText", "Column Data Type.")
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _core.Classes.HTML_SELECT
  }, /*#__PURE__*/_react["default"].createElement("select", {
    value: selectedOption ? selectedOption.id : typeOptions[0].id,
    onChange: function onChange(e) {
      var selection = typeOptions.find(function (option) {
        return option.id === e.target.value;
      });
      if (selection) {
        setType(selection.id);
      }
    }
  }, typeOptions.map(function (option) {
    return /*#__PURE__*/_react["default"].createElement("option", {
      key: option.id,
      value: option.id
    }, option.label);
  }))));
}